<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tr">
      <el-button type="primary" @click="onClickAdd">新增公告</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="sellerNoticeMessageId" label="ID"></el-table-column>
      <el-table-column label="发布日期">
        <template slot-scope="scope">
          {{ scope.row.releaseDate }}
        </template>
      </el-table-column>
      <el-table-column prop="noticeTitle" label="标题"></el-table-column>
      <el-table-column prop="operatorName" label="操作人"></el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          {{ scope.row.updatedAt }}
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.disabledStatus == 2" @click="showDetail(scope.row)">查看</el-link>
          <el-link type="primary" v-if="scope.row.disabledStatus != 2" @click="editItem(scope.row)">编辑</el-link>
        </template>
      </el-table-column>
      <el-table-column label="是否禁用">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.disabledStatus != 2" @click="disabledItem(scope.row)">禁用</el-link>
          <el-tag v-if="scope.row.disabledStatus == 2" type="danger" size="mini">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.topStatus == 2" @click="topItem(scope.row)">取消置顶</el-link>
          <el-link type="primary" v-if="scope.row.topStatus != 2" @click="unTopItem(scope.row)">置顶</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {
  getNoticeList,
  disabledNotice,
  topNotice,
} from "./api";

export default {
  data() {
    return {
      fullscreenLoading: false,
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getNoticeList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    onClickAdd() {
      this.$router.push({ path: '/seller/bulletin/add' });
    },
    showDetail(row) {
      this.$router.push({ path: '/seller/bulletin/show/' + row.sellerNoticeMessageId });
    },
    editItem(row) {
      this.$router.push({ path: '/seller/bulletin/edit/' + row.sellerNoticeMessageId });
    },
    disabledItem(row) {
      this.$confirm('禁用后用户不可见', '是否禁用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        disabledNotice({
          sellerNoticeMessageId: row.sellerNoticeMessageId,
          disabledStatus: 2, // 1：未禁用 2：已禁用
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('发布成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常');
          }
        });
      }).catch(() => {});
    },
    topItem(row) {
      topNotice({
        sellerNoticeMessageId: row.sellerNoticeMessageId,
        topStatus: 1, // 1.置顶 2.取消置顶
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('置顶成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
    unTopItem(row) {
      topNotice({
        sellerNoticeMessageId: row.sellerNoticeMessageId,
        topStatus: 2, // 1.置顶 2.取消置顶
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('取消置顶成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
